import React, { useState, useEffect, Fragment } from "react";
import { doGet, doPost } from "../services/api-service";
import { withRouter } from "react-router";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";

import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";

import Tooltip from "@material-ui/core/Tooltip";
import DebouncedTextField from "../components/DebouncedTextField"
import Modal from "@material-ui/core/Modal";
import Conditional from "../components/Conditional";
import { useMeasure } from "react-use";

const PaDoAssessmentComponent = props => {

    console.log("props", props)

    const arrayScore = [0,1,2,3,4];
    const maxScore = 4;
    const [unsurScores, setUnsurScores] = useState([]);
    const [aspekScores, setAspekScores] = useState([]);
    const [subAspekScores, setSubAspekScores] = useState([]);
    const [grandTotal, setGrandTotal] = useState(0);
    const [category, setCategory] = useState("A");
    const [noteAtasan, setNoteAtasan] = useState("");
    const [isError, setIsError] = useState(false);
    const [isSave, setisSave] = useState(false);
    

    const [countAtasan, setCountAtasan] = useState(1);
    const [colspanBobot, setColspanBobot] = useState(1);
    const [colspanLeader, setColspanLeader] = useState(1);
    const [indexAtasan, setIndexAtasan] = useState();
    const [atasanExistLogin, setAtasanExistLogin] = useState('');
    

    const [alreadyLeader1, setAlreadyLeader1] = useState(0);
    const [alreadyLeader2, setAlreadyLeader2] = useState(0);
    const [alreadyLeader3, setAlreadyLeader3] = useState(0);
    const [alreadyStaff, setAlreadyStaff] = useState(0);
    const [isStaff, setIsStaff] = useState(0);


    const toggleAlreadyStaff = () =>{
        if(props.assessment.fill_by_staff==1 || props.user.emp_id==props.assessment.participant_id){
            setAlreadyStaff(1)
        }else{
            setAlreadyStaff(0)
        }

        if(props.user.emp_id==props.assessment.participant_id){
            setIsStaff(1)
        }else{
            setIsStaff(0)
        }
    }

    const toggleAlreadyLeader = () =>{

        const atasan_ids =  props.assessment.atasan_id.split(',');
        const fill_atasan_ids =  props.assessment.fill_by_nik_atasan.split(',');

        var array_push = [];

        fill_atasan_ids.map(row => {
            let index = atasan_ids.indexOf(row);
            array_push.push(index+1);
        })

        array_push.map(obj=>{

            if(obj==1){
                setAlreadyLeader1(1)
            }

            if(obj==2){
                setAlreadyLeader2(1)
            }

            if(obj==3){
                setAlreadyLeader3(3)
            }

        })

    }

    const toggleTitle = () =>{
        const emp_id = props.user.emp_id;
        console.log(props.assessment.atasan_id)

        const atasans =  props.assessment.atasan_id.split(',');

        
        const atasan_id = atasans.find(obj => {
            return obj === emp_id;
          });

        return props.user.emp_id == atasan_id ? "atasan":"staff"
    }

    useEffect(() => {
        if(props.assessment){

            toggleAlreadyStaff()
            toggleAlreadyLeader()

            console.log("props.assessment.unsurs", props.assessment.unsurs)
  
            let unsurScoreTemp=[]
            unsurScoreTemp = props.assessment.unsurs.map(unsur=>({
                ...unsur, 
                unsur_id:unsur.id,
                oldBobot:unsur.bobot,
                sub_aspek_id:unsur.sub_aspek_id,
                atasanPercentScore:(parseFloat(unsur.atasan_score)*(unsur.bobot/100)),
                atasanPercentScore_2:(parseFloat(unsur.atasan_score_2)*(unsur.bobot/100)),
                atasanPercentScore_3:(parseFloat(unsur.atasan_score_3)*(unsur.bobot/100)),
                staffPercentScore: (parseFloat(unsur.staff_score)*(unsur.bobot/100))
            }));

            // (parseFloat(unsur.atasan_score)*unsur.bobot/100),
            
            const optionalUnsur = unsurScoreTemp.filter(unsur=>(unsur.is_optional===1))
            
            let newUnsurScores = []
            newUnsurScores = [...unsurScoreTemp]
            if(optionalUnsur.length===0){
                newUnsurScores = [...unsurScoreTemp]
            }else{

                unsurScoreTemp.forEach(unsur=>{
                    if(unsur.is_optional===1){
                        //staff
                        if(unsur.staff_score===0){
                            const oldUnsurReceiver = unsurScoreTemp.find(u=>u.code === unsur.receiver_unsur_code)
                            const newUnsurReceiverBobot = parseFloat(oldUnsurReceiver.bobot)+parseFloat(unsur.bobot)

                            // console.log("oldUnsurReceiver.staff_score", oldUnsurReceiver.staff_score);
                            // console.log("newUnsurReceiverBobot", ((newUnsurReceiverBobot)/100));

                            let final = (oldUnsurReceiver.staff_score*((newUnsurReceiverBobot)/100));
                            // console.log("final", final);

                            const newUnsurReceiver = {
                                ...oldUnsurReceiver, 
                                isBobotReceived:true,
                                bobot:newUnsurReceiverBobot,
                                staffPercentScore: (oldUnsurReceiver.staff_score*((newUnsurReceiverBobot)/100))
                            }
                            const otherOldUnsurScore = unsurScoreTemp.filter(u=>(u.id !== unsur.id && u.id !== oldUnsurReceiver.id))
                            newUnsurScores = [...otherOldUnsurScore, {...unsur,bobot:0 },newUnsurReceiver]
                        }
    
                        //atasan
                        if(unsur.atasan_score===0){
                            const oldUnsurReceiver = unsurScoreTemp.find(u=>u.code === unsur.receiver_unsur_code)
                            const newUnsurReceiverBobot = parseFloat(oldUnsurReceiver.bobot)+parseFloat(unsur.bobot)
                            const newUnsurReceiver = {
                                ...oldUnsurReceiver, 
                                isBobotReceived:true,
                                bobot:newUnsurReceiverBobot,
                                atasanPercentScore:(oldUnsurReceiver.atasan_score*((newUnsurReceiverBobot)/100))
                            }
                            const otherOldUnsurScore = unsurScoreTemp.filter(u=>(u.id !== unsur.id && u.id !== oldUnsurReceiver.id))
                            newUnsurScores = [...otherOldUnsurScore, {...unsur,bobot:0 },newUnsurReceiver]
                        }
                        
                    }
                })  
            }
                    

            const aspekScoreTemp = props.assessment.aspeks.map(aspek=>({...aspek, aspek_id:aspek.id}))
            const subAspekScoreTemp = props.assessment.sub_aspeks.map(subAspek=>({...subAspek, sub_aspek_id:subAspek.id, aspek_id:subAspek.aspek_id}))

            const sortedUnsur = newUnsurScores.sort((a, b) => (a.id > b.id) ? 1 : -1)
            
            // console.log("aspekScoreTemp", aspekScoreTemp)

            setUnsurScores(sortedUnsur)
            setAspekScores(aspekScoreTemp)
            setSubAspekScores(subAspekScoreTemp)

            // console.log("subAspekScoreTemp", subAspekScoreTemp)
            setGrandTotal(props.assessment.total_score)

            const atasans =  props.assessment.atasan_id.split(',');

          
            

            const results = atasans.filter(element => {
                return element !== '';
              });

            const jmlatasan = results.length;

         

            const emp_id = props.user.emp_id;
            const index = atasans.indexOf(emp_id.toString());

            console.log("atasans FIXED", atasans)
            console.log("indexATASAN FIXED", emp_id)
            console.log("index KE BERAPA FIXED", atasans.indexOf(emp_id.toString()))

            const index_atasan = index+1;

            setIndexAtasan(index_atasan)

            if(jmlatasan==1){
                setColspanLeader(3)
                setColspanBobot(3)
            }else if(jmlatasan==2){
                setColspanLeader(1)
                setColspanBobot(2)
            }else if(jmlatasan==3){
                setColspanLeader(0)
                setColspanBobot(2)
            }else{
                setColspanLeader(3)
                setColspanBobot(2)
            }

            
            // if(props.assessment.total_score >= 3.5){
            //     setCategory("A")
            // }else if(props.assessment.total_score >= 3){
            //     setCategory("B")
            // }else if(props.assessment.total_score >= 2.5){
            //     setCategory("C")
            // }else{
            //     setCategory("D")
            // }

            if(props.assessment.total_score >= 4.00){
                setCategory("A+")
            }else if(props.assessment.total_score >= 3.40){
                setCategory("A")
            }else if(props.assessment.total_score >= 3.10){
                setCategory("A-")
            }else if(props.assessment.total_score >= 2.80){
                setCategory("B+")
            }else if(props.assessment.total_score >= 2.50){
                setCategory("B")
            }else if(props.assessment.total_score >= 2.20){
                setCategory("B-")
            }else if(props.assessment.total_score >= 1.90){
                setCategory("C+")
            }else if(props.assessment.total_score >= 1.60){
                setCategory("C")
            }else{
                setCategory("D")
            }

        }
    }, [props.assessment])


    const atasanUnsurChange = (unsur_id,e) => {

        let newUnsurScores;
        const oldUnsurScore = unsurScores.find(u=>u.unsur_id === unsur_id)
        if(oldUnsurScore.external_data){
            return
        }

        let scoreValue = parseFloat(e.target.value);

        if(scoreValue>maxScore){
            scoreValue = maxScore
        }


        let scoreOrigin = e.target.value

        if(oldUnsurScore.is_optional===1){
            if(scoreOrigin==='' || scoreValue===''){

                console.log(1)

                const newScore = {...oldUnsurScore, bobot:0, atasan_score:'', atasanPercentScore:0}
                const oldUnsurReceiver = unsurScores.find(u=>u.code === oldUnsurScore.receiver_unsur_code)
                const newUnsurReceiverBobot = parseFloat(oldUnsurReceiver.bobot)+parseFloat(oldUnsurScore.bobot)

                // console.log("atasanPercentScore", (oldUnsurReceiver.atasan_score*((newUnsurReceiverBobot)/100)))

                let atasanPercentScore = scoreOrigin==='' ? (oldUnsurReceiver.atasan_score*((newUnsurReceiverBobot)/100)) : (oldUnsurReceiver.atasan_score*((newUnsurReceiverBobot)/100));

                const newUnsurReceiver = {
                    ...oldUnsurReceiver, 
                    bobot:newUnsurReceiverBobot,
                    atasanPercentScore: atasanPercentScore,
                    isBobotReceived:true
                }
                const otherOldUnsurScore = unsurScores.filter(u=>(u.id !== unsur_id && u.id !== oldUnsurReceiver.id))
                newUnsurScores = [...otherOldUnsurScore, newScore, newUnsurReceiver]
            }else{                
                const newScore = {...oldUnsurScore, bobot:oldUnsurScore.oldBobot, atasan_score:scoreValue, atasanPercentScore:(scoreValue*oldUnsurScore.oldBobot/100)}
                const oldUnsurReceiver = unsurScores.find(u=>u.code === oldUnsurScore.receiver_unsur_code)
                if(oldUnsurReceiver.isBobotReceived){                    
                    const newUnsurReceiverBobot = oldUnsurReceiver.oldBobot

                    // console.log("atasanPercentScore", (oldUnsurReceiver.atasan_score*((newUnsurReceiverBobot)/100)))

                    const newUnsurReceiver = {
                        ...oldUnsurReceiver, 
                        bobot:oldUnsurReceiver.oldBobot,
                        atasanPercentScore:(oldUnsurReceiver.atasan_score*((newUnsurReceiverBobot)/100)),
                        isBobotReceived:false
                    }
                    const otherOldUnsurScore = unsurScores.filter(u=>(u.id !== unsur_id && u.id !== oldUnsurReceiver.id))
                    newUnsurScores = [...otherOldUnsurScore, newScore,newUnsurReceiver]                        
                }else{
                    const otherOldUnsurScore = unsurScores.filter(u=>u.unsur_id !== unsur_id)
                    newUnsurScores = [...otherOldUnsurScore, newScore]        
                }
            }
        }else{


            const atasanScore =  scoreOrigin ==='' ? 0 : scoreValue

            console.log("skore yang diberikan atasan", atasanScore)
            const newScore = {...oldUnsurScore, atasan_score:atasanScore, atasanPercentScore:(atasanScore*oldUnsurScore.bobot/100)}
            console.log("skor", newScore)
            const otherOldUnsurScore = unsurScores.filter(u=>u.unsur_id !== unsur_id)
            newUnsurScores = [...otherOldUnsurScore, newScore]
        }
        const sorted = newUnsurScores.sort((a, b) => (a.id> b.id ) ? 1 : -1)

        // console.log("TEST", sorted)

        setUnsurScores(sorted)

    };

    const atasanUnsurChange2 = (unsur_id,e) => {

        let newUnsurScores;
        const oldUnsurScore = unsurScores.find(u=>u.unsur_id === unsur_id)
        if(oldUnsurScore.external_data){
            return
        }

       
        const scoreValue =  e.target.value ==='' ? 0 : parseFloat(e.target.value)
        
        // console.log(scoreValue)

        if(scoreValue>maxScore){
            scoreValue = maxScore
        }


        let scoreOrigin = e.target.value

        if(oldUnsurScore.is_optional===1){
            if(scoreOrigin==='' || scoreValue===''){

                const newScore = {...oldUnsurScore, bobot:0, atasan_score_2:'', atasanPercentScore_2:0}
                const oldUnsurReceiver = unsurScores.find(u=>u.code === oldUnsurScore.receiver_unsur_code)
                const newUnsurReceiverBobot = parseFloat(oldUnsurReceiver.bobot)+parseFloat(oldUnsurScore.bobot)

                // console.log("atasanPercentScore", (oldUnsurReceiver.atasan_score*((newUnsurReceiverBobot)/100)))

                let atasanPercentScore = scoreOrigin==='' ? (oldUnsurReceiver.atasan_score_2*((newUnsurReceiverBobot)/100)) : (oldUnsurReceiver.atasan_score_2*((newUnsurReceiverBobot)/100));

                const newUnsurReceiver = {
                    ...oldUnsurReceiver, 
                    bobot:newUnsurReceiverBobot,
                    atasanPercentScore_2: atasanPercentScore,
                    isBobotReceived:true
                }
                const otherOldUnsurScore = unsurScores.filter(u=>(u.id !== unsur_id && u.id !== oldUnsurReceiver.id))
                newUnsurScores = [...otherOldUnsurScore, newScore, newUnsurReceiver]
            }else{                
                const newScore = {...oldUnsurScore, bobot:oldUnsurScore.oldBobot, atasan_score_2:scoreValue, atasanPercentScore_2:(scoreValue*oldUnsurScore.oldBobot/100)}
                const oldUnsurReceiver = unsurScores.find(u=>u.code === oldUnsurScore.receiver_unsur_code)
                if(oldUnsurReceiver.isBobotReceived){                    
                    const newUnsurReceiverBobot = oldUnsurReceiver.oldBobot

                    // console.log("atasanPercentScore", (oldUnsurReceiver.atasan_score*((newUnsurReceiverBobot)/100)))

                    const newUnsurReceiver = {
                        ...oldUnsurReceiver, 
                        bobot:oldUnsurReceiver.oldBobot,
                        atasanPercentScore_2:(oldUnsurReceiver.atasan_score_2*((newUnsurReceiverBobot)/100)),
                        isBobotReceived:false
                    }
                    const otherOldUnsurScore = unsurScores.filter(u=>(u.id !== unsur_id && u.id !== oldUnsurReceiver.id))
                    newUnsurScores = [...otherOldUnsurScore, newScore,newUnsurReceiver]                        
                }else{
                    const otherOldUnsurScore = unsurScores.filter(u=>u.unsur_id !== unsur_id)
                    newUnsurScores = [...otherOldUnsurScore, newScore]        
                }
            }
        }else{

            const atasanScore =  scoreOrigin ==='' ? 0 : scoreValue
            const newScore = {...oldUnsurScore, atasan_score_2:atasanScore, atasanPercentScore_2:(atasanScore*oldUnsurScore.bobot/100)}
            const otherOldUnsurScore = unsurScores.filter(u=>u.unsur_id !== unsur_id)
            newUnsurScores = [...otherOldUnsurScore, newScore]
        }
        const sorted = newUnsurScores.sort((a, b) => (a.id> b.id ) ? 1 : -1)

        // console.log("TEST", sorted)

        setUnsurScores(sorted)

    };

    // const atasanUnsurChange2 = (unsur_id,e) => {

    //     let newUnsurScores;
    //     const oldUnsurScore = unsurScores.find(u=>u.unsur_id === unsur_id)
    //     if(oldUnsurScore.external_data){
    //         return
    //     }

    //     let scoreValue = parseFloat(e.target.value);
    //     if(scoreValue>maxScore){
    //         scoreValue = maxScore
    //     }


    //     let scoreOrigin = e.target.value

    //     if(oldUnsurScore.is_optional===1){
    //         if(scoreOrigin==='' || scoreValue===''){
                
    //             const newScore = {...oldUnsurScore, bobot:0, atasan_score_2:'', atasanPercentScore_2:0}
    //             const oldUnsurReceiver = unsurScores.find(u=>u.code === oldUnsurScore.receiver_unsur_code)
    //             const newUnsurReceiverBobot = parseFloat(oldUnsurReceiver.bobot)+parseFloat(oldUnsurScore.bobot)
    //             const newUnsurReceiver = {
    //                 ...oldUnsurReceiver, 
    //                 bobot:newUnsurReceiverBobot,
    //                 atasanPercentScore_2:(parseFloat(oldUnsurReceiver.atasan_score_2)*((newUnsurReceiverBobot)/100)),
    //                 isBobotReceived:true
    //             }

    //             console.log("newUnsurReceiver", newUnsurReceiver)
    //             console.log("newScore", newScore)
    //             const otherOldUnsurScore = unsurScores.filter(u=>(u.id !== unsur_id && u.id !== oldUnsurReceiver.id))


    //             newUnsurScores = [...otherOldUnsurScore, newScore,newUnsurReceiver]
    //         }else{                
    //             const newScore = {...oldUnsurScore, bobot:oldUnsurScore.oldBobot, atasan_score_2:scoreValue, atasanPercentScore_2:(scoreValue*oldUnsurScore.oldBobot/100)}
    //             const oldUnsurReceiver = unsurScores.find(u=>u.code === oldUnsurScore.receiver_unsur_code)
    //             if(oldUnsurReceiver.isBobotReceived){                    
    //                 const newUnsurReceiverBobot = oldUnsurReceiver.oldBobot
    //                 const newUnsurReceiver = {
    //                     ...oldUnsurReceiver, 
    //                     bobot:oldUnsurReceiver.oldBobot,
    //                     atasanPercentScore_2:(oldUnsurReceiver.atasan_score_2*((newUnsurReceiverBobot)/100)),
    //                     isBobotReceived:false
    //                 }
    //                 const otherOldUnsurScore = unsurScores.filter(u=>(u.id !== unsur_id && u.id !== oldUnsurReceiver.id))

    //                 console.log("newUnsurReceiver", newUnsurReceiver)
    //                 console.log("newScore", newScore)

    //                 newUnsurScores = [...otherOldUnsurScore, newScore,newUnsurReceiver]                        
    //             }else{
    //                 const otherOldUnsurScore = unsurScores.filter(u=>u.unsur_id !== unsur_id)

    //                 console.log("otherOldUnsurScore", otherOldUnsurScore)

    //                 newUnsurScores = [...otherOldUnsurScore, newScore]        
    //             }
    //         }
    //     }else{

    //         const atasanScore =  scoreOrigin ==='' ? 0 : scoreValue

    //         const newScore = {...oldUnsurScore, atasan_score_2:atasanScore, atasanPercentScore_2:(atasanScore*oldUnsurScore.bobot/100)}
    //         const otherOldUnsurScore = unsurScores.filter(u=>u.unsur_id !== unsur_id)
    //         newUnsurScores = [...otherOldUnsurScore, newScore]

    //         //cek jika score tidak berubah
    //         // console.log("NEW SCORE", newScore);
    //         // console.log("OLD UNSUR", oldUnsurScore);
    //     }
    //     const sorted = newUnsurScores.sort((a, b) => (a.id> b.id ) ? 1 : -1)

    //     setUnsurScores(sorted)

    // };

    const atasanUnsurChange3 = (unsur_id,e) => {

        let newUnsurScores;
        const oldUnsurScore = unsurScores.find(u=>u.unsur_id === unsur_id)
        if(oldUnsurScore.external_data){
            return
        }

        let scoreValue = parseFloat(e.target.value);
        if(scoreValue>maxScore){
            scoreValue = maxScore
        }

        let scoreOrigin = e.target.value

        if(oldUnsurScore.is_optional===1){
            if(scoreOrigin===''){
                
                const newScore = {...oldUnsurScore, bobot:0, atasan_score_3:'', atasanPercentScore_3:0}
                const oldUnsurReceiver = unsurScores.find(u=>u.code === oldUnsurScore.receiver_unsur_code)
                const newUnsurReceiverBobot = parseFloat(oldUnsurReceiver.bobot)+parseFloat(oldUnsurScore.bobot)
                const newUnsurReceiver = {
                    ...oldUnsurReceiver, 
                    bobot:newUnsurReceiverBobot,
                    atasanPercentScore_3:(oldUnsurReceiver.atasan_score_3*((newUnsurReceiverBobot)/100)),
                    isBobotReceived:true
                }
                const otherOldUnsurScore = unsurScores.filter(u=>(u.id !== unsur_id && u.id !== oldUnsurReceiver.id))
                newUnsurScores = [...otherOldUnsurScore, newScore,newUnsurReceiver]
            }else{                
                const newScore = {...oldUnsurScore, bobot:oldUnsurScore.oldBobot, atasan_score_3:scoreValue, atasanPercentScore_3:(scoreValue*oldUnsurScore.oldBobot/100)}
                const oldUnsurReceiver = unsurScores.find(u=>u.code === oldUnsurScore.receiver_unsur_code)
                if(oldUnsurReceiver.isBobotReceived){                    
                    const newUnsurReceiverBobot = oldUnsurReceiver.oldBobot
                    const newUnsurReceiver = {
                        ...oldUnsurReceiver, 
                        bobot:oldUnsurReceiver.oldBobot,
                        atasanPercentScore_3:(oldUnsurReceiver.atasan_score_3*((newUnsurReceiverBobot)/100)),
                        isBobotReceived:false
                    }
                    const otherOldUnsurScore = unsurScores.filter(u=>(u.id !== unsur_id && u.id !== oldUnsurReceiver.id))
                    newUnsurScores = [...otherOldUnsurScore, newScore,newUnsurReceiver]                        
                }else{
                    const otherOldUnsurScore = unsurScores.filter(u=>u.unsur_id !== unsur_id)
                    newUnsurScores = [...otherOldUnsurScore, newScore]        
                }
            }
        }else{

            const atasanScore =  scoreOrigin ==='' ? 0 : scoreValue

            const newScore = {...oldUnsurScore, atasan_score_3:atasanScore, atasanPercentScore_3:(atasanScore*oldUnsurScore.bobot/100)}
            const otherOldUnsurScore = unsurScores.filter(u=>u.unsur_id !== unsur_id)
            newUnsurScores = [...otherOldUnsurScore, newScore]
        }
        const sorted = newUnsurScores.sort((a, b) => (a.id> b.id ) ? 1 : -1)

        setUnsurScores(sorted)

    };

    const staffUnsurChange = (unsur_id,e) => {

        let newUnsurScores;
        const oldUnsurScore = unsurScores.find(u=>u.unsur_id === unsur_id)
        if(oldUnsurScore.external_data){
            return
        }

        let scoreValue = parseFloat(e.target.value);
        if(scoreValue>maxScore){
            scoreValue = maxScore
        }

        let scoreOrigin = e.target.value

        if(oldUnsurScore.is_optional===1){
            
            if(scoreOrigin===0){
                
                const newScore = {...oldUnsurScore, bobot:0, staff_score:'', staffPercentScore:0}
                const oldUnsurReceiver = unsurScores.find(u=>u.code === oldUnsurScore.receiver_unsur_code)
                const newUnsurReceiverBobot = parseFloat(oldUnsurReceiver.bobot)+parseFloat(oldUnsurScore.bobot)
                const newUnsurReceiver = {
                    ...oldUnsurReceiver, 
                    bobot:newUnsurReceiverBobot,
                    staffPercentScore:(oldUnsurReceiver.staff_score*((newUnsurReceiverBobot)/100)),
                    isBobotReceived:true
                }
                const otherOldUnsurScore = unsurScores.filter(u=>(u.id !== unsur_id && u.id !== oldUnsurReceiver.id))
                newUnsurScores = [...otherOldUnsurScore, newScore,newUnsurReceiver]
            }else{                
                const newScore = {...oldUnsurScore, bobot:oldUnsurScore.oldBobot, staff_score:scoreValue, staffPercentScore:(scoreValue*oldUnsurScore.oldBobot/100)}
                const oldUnsurReceiver = unsurScores.find(u=>u.code === oldUnsurScore.receiver_unsur_code)
                if(oldUnsurReceiver.isBobotReceived){                    
                    const newUnsurReceiverBobot = oldUnsurReceiver.oldBobot
                    const newUnsurReceiver = {
                        ...oldUnsurReceiver, 
                        bobot:oldUnsurReceiver.oldBobot,
                        staffPercentScore:(oldUnsurReceiver.staff_score*((newUnsurReceiverBobot)/100)),
                        isBobotReceived:false
                    }
                    const otherOldUnsurScore = unsurScores.filter(u=>(u.id !== unsur_id && u.id !== oldUnsurReceiver.id))
                    newUnsurScores = [...otherOldUnsurScore, newScore,newUnsurReceiver]                        
                }else{
                    const otherOldUnsurScore = unsurScores.filter(u=>u.unsur_id !== unsur_id)
                    newUnsurScores = [...otherOldUnsurScore, newScore]        
                }
            }
            
        }else{
            
            const newScore = {...oldUnsurScore, staff_score:scoreValue, staffPercentScore:(scoreValue*oldUnsurScore.bobot/100)}
            const otherOldUnsurScore = unsurScores.filter(u=>u.unsur_id !== unsur_id)
            newUnsurScores = [...otherOldUnsurScore, newScore]
        }
        

        const sorted = newUnsurScores.sort((a, b) => (a.id > b.id) ? 1 : -1)
        setUnsurScores(sorted)
    };


    useEffect(() => {



        const newSubAspekScores = subAspekScores.map(sub=>{
            const filteredUnsurScores = unsurScores.filter(unsur=>(unsur.sub_aspek_id===sub.sub_aspek_id))

            
            // console.log("filteredUnsurScores", filteredUnsurScores)
            const newScoreFromAtasan = filteredUnsurScores.reduce((acc,current)=>acc + current.atasanPercentScore,0)
            const newScoreFromAtasan_2 = filteredUnsurScores.reduce((acc,current)=>acc + current.atasanPercentScore_2,0)
            const newScoreFromAtasan_3 = filteredUnsurScores.reduce((acc,current)=>acc + current.atasanPercentScore_3,0)
            const newScoreFromStaff = filteredUnsurScores.reduce((acc,current)=>acc + current.staffPercentScore,0)


            // console.log("newScoreFromAtasan", newScoreFromAtasan)

            let scoreLeder1 = 0;
            let scoreLeder2 = 0;
            let scoreLeder3 = 0;


           // console.log("AVERAGE", average_atasan/3)
           let atasansFill = props.assessment.fill_by_nik_atasan.split(',');
           let atasans = props.assessment.atasan_id.split(',');
           let jmlAtasan = atasans.length
           

           const emp_id = props.user.emp_id;
           const indexAtasan = atasans.indexOf(emp_id.toString())+1;

           console.log("jmlAtasan", jmlAtasan)

           setCountAtasan(jmlAtasan)

           let atasanExistLogin = atasans.filter(function(value) {
           return value == emp_id });

        //    console.log("atasanExistLogin", atasanExistLogin[0])

           setAtasanExistLogin(atasanExistLogin[0])

        //    console.log("emp_id", emp_id)
        //    console.log("jmlAtasan", jmlAtasan)
        //    console.log("indexAtasan", indexAtasan)
        //    console.log("alreadyLeader1", alreadyLeader1)
        //    console.log("alreadyLeader2", alreadyLeader2)
        //    console.log("alreadyLeader3", alreadyLeader3)


        //   if(alreadyLeader1==1 || indexAtasan==1){
                scoreLeder1 = newScoreFromAtasan
        //    }
           
        //    if(alreadyLeader2==1 || indexAtasan==2){
                scoreLeder2 = newScoreFromAtasan_2
        //    }

        //    if(alreadyLeader3==1 || indexAtasan==3){
               scoreLeder3 = newScoreFromAtasan_3
        //   }

          const atasansFillresults = atasansFill.filter(element => {
            return element !== '';
          });

            // console.log("scoreLeder1", scoreLeder1)
            // console.log("scoreLeder2", scoreLeder2)
            // console.log("atasansFill.length", atasansFillresults.length)
             let average_atasan = 0;// parseFloat(newScoreFromAtasan);
             // const average_atasan = (parseFloat(scoreLeder1) + parseFloat(scoreLeder2) + parseFloat(scoreLeder3)) / atasansFill.length;
            

            const scores = [scoreLeder1, scoreLeder2, scoreLeder3];

            console.log("scores", scores)
            const filteredScores = scores.filter((_, index) => atasansFillresults.includes(index + 1));         
             if (filteredScores.length === 0) {
                average_atasan = indexAtasan >= 1 && indexAtasan <= 3 ? parseFloat(scores[indexAtasan - 1]) : 0;
            } else {
                average_atasan = filteredScores.reduce((sum, score) => sum + parseFloat(score), 0) / filteredScores.length;
            }
            
            if(atasansFillresults.length==0){
                if(indexAtasan==1){
                    average_atasan = parseFloat(scoreLeder1) / 1;
                }else if(indexAtasan==2){
                    average_atasan = parseFloat(scoreLeder2) / 1;
                }else if(indexAtasan==3){
                    average_atasan = parseFloat(scoreLeder3) / 1;
                }               
            }else if(atasansFillresults.length==1){

                if(indexAtasan==1){

                    if(alreadyLeader2==1){
                        average_atasan = (parseFloat(scoreLeder1) + parseFloat(scoreLeder2) ) / 2;
                    }

                    if(alreadyLeader3==1){
                        average_atasan = (parseFloat(scoreLeder1) + parseFloat(scoreLeder3) ) / 2;
                    }
                   
                }

                if(indexAtasan==2){

                    if(alreadyLeader1==1){
                        average_atasan = (parseFloat(scoreLeder2) + parseFloat(scoreLeder1) ) / 2;
                    }

                    if(alreadyLeader3==1){
                        average_atasan = (parseFloat(scoreLeder2) + parseFloat(scoreLeder3) ) / 2;
                    }

                    // average_atasan = (parseFloat(scoreLeder2) + parseFloat(scoreLeder2) ) / 2;
                }

                if(indexAtasan==3){

                    if(alreadyLeader2==1){
                        average_atasan = (parseFloat(scoreLeder3) + parseFloat(scoreLeder2) ) / 2;
                    }

                    if(alreadyLeader1==1){
                        average_atasan = (parseFloat(scoreLeder3) + parseFloat(scoreLeder1) ) / 2;
                    }
                    // average_atasan = (parseFloat(scoreLeder3) + parseFloat(scoreLeder2) ) / 2;
                }
            

            }else if(atasansFillresults.length==2){
                average_atasan = (parseFloat(scoreLeder1) + parseFloat(scoreLeder2) ) / 2;
            }else if(atasansFillresults.length==3){
                average_atasan = (parseFloat(scoreLeder1) + parseFloat(scoreLeder2) + parseFloat(scoreLeder3) ) / 3;
            }



            // console.log("scoreLeder1", scoreLeder1)
            // console.log("scoreLeder2", scoreLeder2)
            // console.log("average_atasan", average_atasan)
            // console.log("alreadyLeader1", alreadyLeader1)
            // console.log("alreadyLeader2", alreadyLeader2)
            // console.log("alreadyLeader3", alreadyLeader3)
            // console.log("index_atasan", indexAtasan)
            // console.log("atasansFillresults.length", atasansFillresults.length)


             if(props.assessment.fill_by_staff==0){

                return {...sub, score:parseFloat(average_atasan)}
        
            }else{
                return {...sub, score:(
                    (parseFloat(average_atasan))
                    // +
                    // (parseFloat(newScoreFromStaff) * (props.assessment.bobot_bawahan/100)) 
                )}
            }
            
            // return {...sub, score:(
            //     (newScoreFromAtasan * props.assessment.bobot_atasan/100)
            //     +
            //     (newScoreFromAtasan_2 * props.assessment.bobot_atasan/100)
            //     +
            //     (newScoreFromAtasan_3 * props.assessment.bobot_atasan/100)
            //     +
            //     (newScoreFromStaff * props.assessment.bobot_bawahan/100) )}
                
        })


        const newSubAspekScores_staff = subAspekScores.map(sub=>{
            const filteredUnsurScores = unsurScores.filter(unsur=>(unsur.sub_aspek_id===sub.sub_aspek_id))

            const newScoreFromAtasan = filteredUnsurScores.reduce((acc,current)=>acc + current.atasanPercentScore,0)
            const newScoreFromAtasan_2 = filteredUnsurScores.reduce((acc,current)=>acc + current.atasanPercentScore_2,0)
            const newScoreFromAtasan_3 = filteredUnsurScores.reduce((acc,current)=>acc + current.atasanPercentScore_3,0)
            const newScoreFromStaff = filteredUnsurScores.reduce((acc,current)=>acc + current.staffPercentScore,0)

            let scoreLeder1 = 0;
            let scoreLeder2 = 0;
            let scoreLeder3 = 0;


            // scoreLeder1 = newScoreFromAtasan
            // scoreLeder2 = newScoreFromAtasan_2
            // scoreLeder3 = newScoreFromAtasan_3

            let atasansFill = props.assessment.fill_by_nik_atasan.split(',');
            let atasans = props.assessment.atasan_id.split(',');
            let jmlAtasan = atasans.length

            const atasansFillresults = atasansFill.filter(element => {
                return element !== '';
            });

            const index = atasansFillresults.map(fill=>{
                const index = atasans.indexOf(fill.toString());
                return index+1
            })

            console.log('atasansFill', atasansFillresults)
            console.log('atasans', atasans)
            console.log('index', index)
        

            const emp_id = props.user.emp_id;
            const indexAtasan = atasans.indexOf(emp_id.toString())+1;

            setCountAtasan(jmlAtasan)

            let atasanExistLogin = atasans.filter(function(value) {
            return value == emp_id });

            console.log("scoreLeder222", scoreLeder2)

            setAtasanExistLogin(atasanExistLogin[0])

             index.map(ind=>{
               if(ind==1){
                scoreLeder1 = newScoreFromAtasan
               }

               if(ind==2){
                scoreLeder2 = newScoreFromAtasan_2
               }

               if(ind==3){
                scoreLeder3 = newScoreFromAtasan_3
               }

             })


             let average_atasan = 0;

             if(index.length>0){
                average_atasan = ( parseFloat(scoreLeder1) + parseFloat(scoreLeder2) + parseFloat(scoreLeder3) ) / (atasansFillresults.length === 0 ? 1 : atasansFillresults.length)
             }


            return {...sub, score:(
                (parseFloat(average_atasan))
            )}

                
        })

 


        if(isStaff){
            setSubAspekScores(newSubAspekScores_staff)
        }else{
            setSubAspekScores(newSubAspekScores)
        }

        
        
    }, [unsurScores])


    useEffect(() => {
        const newAspekScores = aspekScores.map(aspek=>{
            const newScore = subAspekScores.filter(sub=>sub.aspek_id===aspek.aspek_id)
            .reduce((acc,current)=>acc+current.score,0)

            return {...aspek, score:newScore}
        })


        // console.log("aspekScores", aspekScores)
        // console.log("subAspekScores", subAspekScores)

        // console.log("newAspekScores", newAspekScores)
        console.log('ok')
        setAspekScores(newAspekScores)

        // console.log("NEW ASPEK",newAspekScores);

    }, [subAspekScores])

    useEffect(() => {
        const sumAspekScore = aspekScores.reduce((acc,current)=>acc+current.score,0)
        setGrandTotal(sumAspekScore)
        // if(sumAspekScore > 3.5){
        //     setCategory("A")
        // }else if(sumAspekScore > 3){
        //     setCategory("B")
        // }else if(sumAspekScore > 2.5){
        //     setCategory("C")
        // }else{
        //     setCategory("D")
        // }

        if(sumAspekScore >= 3.70){
            setCategory("A+")
        }else if(sumAspekScore >= 3.40){
            setCategory("A")
        }else if(sumAspekScore >= 3.10){
            setCategory("A-")
        }else if(sumAspekScore >= 2.80){
            setCategory("B+")
        }else if(sumAspekScore >= 2.50){
            setCategory("B")
        }else if(sumAspekScore >= 2.20){
            setCategory("B-")
        }else if(sumAspekScore >= 1.90){
            setCategory("C+")
        }else if(sumAspekScore >= 1.60){
            setCategory("C")
        }else{
            setCategory("D")
        }



    }, [aspekScores])


    const handleSubmit = async () => {

        // let mandatoryZero
        // if(props.user.emp_id == props.assessment.atasan_id){
        //     mandatoryZero = unsurScores.find(unsur=> unsur.is_optional===0 && unsur.atasan_score===0)
        // }else{
        //     mandatoryZero = unsurScores.find(unsur=> unsur.is_optional===0 && unsur.staff_score===0)
        // }
        // if(mandatoryZero){
        //     setIsError(true)
        //     return
        // }

        setisSave(true)
        create();

        setTimeout(() => {
            props.history.goBack();
            setisSave(false)
            }, 2000);

              

        
    };

    const noteChange = (value,optional) => {
        setNoteAtasan(value)
    };



    const create = async () => {

        const emp_id = props.user.emp_id;
        const atasans =  props.assessment.atasan_id.split(',');

        const atasan_id = atasans.find(obj => {
            return obj === emp_id.toString();
        });


        const role = props.user.emp_id == atasan_id ? "atasan":"staff"

        const index = atasans.indexOf(emp_id.toString());
        const index_atasan = index+1;
        
            const params = {
                assessment_users_id: props.assessment.id,
                score_by: role,
                aspekScores:aspekScores,
                subAspekScores:subAspekScores,
                unsurScores:unsurScores,
                total_score : grandTotal,
                note_atasan : noteAtasan,
                atasan_index : index_atasan,
                atasan_id: atasan_id,
                emp_id: emp_id,
            };


       let result =  await doPost("pa/assessment/do", params, "save submit assessment score");
        
       console.log("result", result)
       return result;
    };

    const { classes } = props;

    const CategoryLabel = ({role,unsur}) => {
        let label = ""
        let score = role==="atasan_1" ? unsur.atasan_score : role==="atasan_2" ? unsur.atasan_score_2 : role==="atasan_3" ? unsur.atasan_score_3 : unsur.staff_score

        // console.log()
        if(score == 0){
            label =  unsur.category_0_label
        }else if(score == 1){
            label = unsur.category_1_label
        }else if(score == 2){
            label = unsur.category_2_label
        }else if(score== 3){
            label = unsur.category_3_label
        }else if(score == 4){
            label = unsur.category_4_label
        }else if(score === ''){
            label = ''
        }
        
        if(score===''){
            return <span></span>
        }else{  
            return <span>{label}</span>
        }   
       
    }


    if(props.assessment && props.user){

        return (

            <React.Fragment>
                <Grid container className={classes.container}>
                    <Grid item xs={12}>
                        <Typography
                            variant="h6"
                            gutterBottom
                            className="animated slideInLeft"
                        >
                            {toggleTitle()==="atasan" && `Assessment As Leader for ${props.assessment.participant_name}` || "Assessment sheet"}
                         
                        </Typography>
                    </Grid>

                    <Grid item xs={12} container direction="column">

                        <Grid container className={classes.table_header}>
                            <Grid item xs={countAtasan < 2 ? 4 :countAtasan ==3 ? 5 : 4} container justify="center">Indicator</Grid>
                            <Grid item xs={1} container justify="flex-end">weight</Grid>
                            <Conditional condition={countAtasan>0}>
                                
                                <Grid item xs={colspanLeader+1} container justify="center">
                                
                                <Conditional condition={indexAtasan==1}><span  style={{marginLeft:80}}>
                                    <Conditional condition={alreadyLeader1==0 && indexAtasan==1}>
                                        <Tooltip title="Belum Isi">
                                            <span className={classes.notFilled}>*</span>
                                        </Tooltip>
                                    </Conditional>
                                     Leader 1 <br /><br />{props.assessment.bobot_atasan}  %</span></Conditional>
                                </Grid>
                            </Conditional>
                            <Conditional condition={countAtasan>1}>
                                <Grid item xs={colspanLeader+1} container justify="center">
                                <Conditional condition={alreadyLeader2==0 && indexAtasan==2}>
                                    <Tooltip title="Belum Isi">
                                        <span className={classes.notFilled}>*</span>
                                    </Tooltip>
                                </Conditional>
                                <Conditional condition={indexAtasan==2}>Leader 2 <br /><br />{props.assessment.bobot_atasan}  %</Conditional>
                                </Grid>
                                </Conditional>
                            <Conditional condition={countAtasan>2}>
                                <Grid item xs={colspanLeader+1} container justify="center" style={{marginRight:50}}>
                                    <Conditional condition={alreadyLeader3==0  && indexAtasan==3}>
                                        <Tooltip title="Belum Isi">
                                            <span className={classes.notFilled}>*</span>
                                        </Tooltip>
                                    </Conditional>
                                    <Conditional condition={indexAtasan==3}>Leader 3 <br /><br />{props.assessment.bobot_atasan}  %</Conditional>
                                </Grid>
                                </Conditional>

                             <Grid item xs={1} container justify="center">
                                 <Conditional condition={alreadyStaff==0}>
                                    <Tooltip title="Belum Isi">
                                        <span className={classes.notFilled}>*</span>
                                    </Tooltip>
                                </Conditional>Staff <br /><br />{props.assessment.bobot_bawahan} %
                            </Grid>
         

                            <Grid item xs={countAtasan>2?2:1} container justify="flex-end">Total</Grid>
                        </Grid>


                       
                        <Grid container>
                                {aspekScores.map(aspek => (
                                    <Grid key={aspek.id} container className={classes.aspek_container}>
                                        <Grid container className={classes.aspek_row}>
                                            <Grid item xs={1}>{aspek.code}</Grid>
                                            <Grid item xs={5}>{aspek.name}</Grid>
                                            <Grid item xs={6} className={classes.aspek_score}>
                                                {
                                                    aspek.score.toFixed(2)
                                                }
                                            </Grid>
                                        </Grid>
                                        {subAspekScores
                                            .filter(a => a.aspek_id === aspek.id)
                                            .map(sub_aspek => (
                                                <Grid key={sub_aspek.id} container className={classes.sub_aspek}>
                                                    <Grid container className={classes.sub_aspek_row}>
                                                        <Grid item xs={1}>{sub_aspek.code}</Grid>
                                                        <Grid item xs={5}>{sub_aspek.name}</Grid>
                                                        <Grid item xs={6} className={classes.sub_aspek_score}>
                                                        {
                                                            sub_aspek.score.toFixed(2)
                                                        }
                                                        </Grid>
                                                    </Grid>
                                                    {unsurScores
                                                        .filter(u =>u.sub_aspek_id === sub_aspek.id)
                                                        .map(unsur => (
                                                            <Grid key={unsur.id} container className={classes.unsur}>
                                                                <Grid container className={classes.unsur_row}>
                                                                    <Grid item xs={1}>{unsur.code}</Grid>
                                                                    <Grid item xs={countAtasan==2?3:3}>
                                                                        
                                                                        {/* {unsur.name} */}
                                                                    {unsur.name.split('\n').map((item, key) => {
                                                                        return <Fragment key={key}>{item}<br/></Fragment>
                                                                    })}
                                                                    </Grid>
                                                                    <Conditional condition={indexAtasan===1}>
                                                                    <Grid item xs={1} style={{marginLeft:50}}>{unsur.bobot}%&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Grid>
                                                                    </Conditional>

                                                                    <Conditional condition={indexAtasan!==1}>
                                                                    <Grid item xs={1}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{unsur.bobot}%&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Grid>
                                                                    </Conditional>
                                                                    

                                                                    <Conditional condition={countAtasan>0}>
                                                               
                                                                        <Conditional condition={indexAtasan===1}>
                                                                          
                                                                            <Grid item xs={colspanLeader+1} container={countAtasan==3 || countAtasan==2  ? false : true} justify={countAtasan==3 || countAtasan==2 ? 'left' : 'center'}>
                                                                               
                                                                                <Grid item container spacing={8} justify="left" alignItems="top" className={classes.unsur_score} >
                                                                                    <Grid item >
                                                                                        {unsur.is_optional===1 &&
                                                                                            <Tooltip title="optional">
                                                                                                <span className={classes.optional}>*</span>
                                                                                            </Tooltip>
                                                                                        }

                                                                                        {unsur.external_data &&
                                                                                            <Tooltip title="external data">
                                                                                                  <span className={classes.optional}>* </span>
                                                                                            </Tooltip>
                                                                                        }
                                                                                        
                                                                                        <TextField
                                                                                        // style = {{width: 40}} 
                                                                                        type="number"
                                                                                        margin="dense"
                                                                                        InputLabelProps={{
                                                                                            shrink: true
                                                                                        }}
                                                                                        inputProps={{
                                                                                            min:
                                                                                                "0",
                                                                                            max:
                                                                                                "4",
                                                                                            step:
                                                                                                "0"
                                                                                        }}
                                                                                        onChange={(event)=>atasanUnsurChange(unsur.id,event)}
                                                                                        id="atasan_score_1"
                                                                                        value={
                                                                                            unsur.atasan_score
                                                                                        }
                                                                                        />
                                                                                 
                                                                                       <br />
                                                                                       <br />
                                                                                       
                                                                                       <CategoryLabel role="atasan_1" unsur={unsur}/><br /><br />
                                                                                            {/* </Grid>
                                                                                            &nbsp;
                                                                                            <Grid item> */}

                                                                                        
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </Grid>

                                                                        </Conditional>

                                                                        

                                                                        <Conditional condition={indexAtasan!==1}>
                                                                            <Grid item xs={colspanLeader+1} container={countAtasan==3 || countAtasan==2  ? false : true} justify={countAtasan==3 || countAtasan==2 ? 'left' : 'center'}>
                                                                                {/* {unsur.atasan_score}&nbsp;<br/><CategoryLabel role="atasan_1" unsur={unsur}/> */}
                                                                               
                                                                                </Grid>            
                                                                        </Conditional>

                                                                        
                                                                    </Conditional>                                                 

                                                                    <Conditional condition={countAtasan>1}>
                                                                                            
                                                                        <Conditional condition={indexAtasan===2}>
                                                                                <Grid item xs={colspanLeader+1} container={countAtasan==3 || countAtasan==2  ? false : true} justify={countAtasan==3 || countAtasan==2 ? 'left' : 'center'}>
                                                                                <Grid item spacing={8} justify="left" alignItems="top" className={classes.unsur_score}>
                                                                                    {unsur.is_optional===1 &&
                                                                                        <Tooltip title="optional">
                                                                                            <span className={classes.optional}>*</span>
                                                                                        </Tooltip>
                                                                                    }

                                                                                    {unsur.external_data &&
                                                                                        <Tooltip title="external data">
                                                                                            <span className={classes.optional}>*</span>
                                                                                        </Tooltip>
                                                                                    }
                                                                                
                                                                                {/* </Grid>
                                                                                <Grid item> */}
                                                                                        <br />
                                                                                        <br />
                                                                                    <TextField
                                                                                    type="number"
                                                                                    margin="dense"
                                                                                    InputLabelProps={{
                                                                                        shrink: true
                                                                                    }}
                                                                                    inputProps={{
                                                                                        min:
                                                                                            "0",
                                                                                        max:
                                                                                            "4",
                                                                                        step:
                                                                                            "0"
                                                                                    }}
                                                                                    onChange={(event)=>atasanUnsurChange2(unsur.id,event)}
                                                                                    id="atasan_score_2"
                                                                                    value={
                                                                                        unsur.atasan_score_2
                                                                                    }
                                                                                    />

                                                                                    

                                                                                    <br />
                                                                                    <br />
                                                                                    <CategoryLabel role="atasan_2" unsur={unsur}/>
                                                                                </Grid>
                                                                            </Grid>

                                                                        </Conditional>

                                                                        <Conditional condition={indexAtasan!==2}>
                                                                            <Grid item xs={colspanLeader+1} container={countAtasan==3 || countAtasan==2  ? false : true} justify={countAtasan==3 || countAtasan==2 ? 'left' : 'center'}>
                                                                                {/* {unsur.atasan_score_2}&nbsp;<br/><CategoryLabel role="atasan_2" unsur={unsur}/> */}
                                                                            </Grid>            
                                                                        </Conditional>

                                                                    </Conditional>

                                                                    <Conditional condition={countAtasan>2}>
                                                                        <Conditional condition={indexAtasan===3}>
                                                                        <Grid item xs={colspanLeader+1} container={countAtasan==3 || countAtasan==2  ? false : true} justify={countAtasan==3 || countAtasan==2 ? 'left' : 'center'} style={{marginRight:50}}>
                                                                                <Grid item spacing={8} justify="left" alignItems="top" className={classes.unsur_score}>
                                                                                    {unsur.is_optional===1 &&
                                                                                        <Tooltip title="optional">
                                                                                            <span className={classes.optional}>*</span>
                                                                                        </Tooltip>
                                                                                    }

                                                                                    {unsur.external_data &&
                                                                                        <Tooltip title="external data">
                                                                                            <span className={classes.optional}>*</span>
                                                                                        </Tooltip>
                                                                                    }
                                                                                    
                                                                                {/* </Grid>
                                                                                
                                                                                <Grid item> */}
                                                                                    
                                                                                    <TextField
                                                                                    type="number"
                                                                                    margin="dense"
                                                                                    InputLabelProps={{
                                                                                        shrink: true
                                                                                    }}
                                                                                    inputProps={{
                                                                                        min:
                                                                                            "0",
                                                                                        max:
                                                                                            "4",
                                                                                        step:
                                                                                            "0"
                                                                                    }}
                                                                                    onChange={(event)=>atasanUnsurChange3(unsur.id,event)}
                                                                                    id="atasan_score_3"
                                                                                    value={
                                                                                        unsur.atasan_score_3
                                                                                    }
                                                                                    />

                                                                                    <br />
                                                                                    <br />

                                                                                    <CategoryLabel role="atasan_3" unsur={unsur}/>
                                                                                </Grid>
                                                                            </Grid>

                                                                        </Conditional>

                                                                        <Conditional condition={indexAtasan!==3}>
                                                                            <Grid item xs={colspanLeader+1} container={countAtasan==3 || countAtasan==2 ? false : true} justify={countAtasan==3 || countAtasan==2 ? 'left' : 'center'}>
                                                                                {/* {unsur.atasan_score_3}&nbsp;<br/><CategoryLabel role="atasan_3" unsur={unsur}/> */}
                                                                            </Grid>
                                                                        </Conditional>           

                                                                    </Conditional>

                                                                    <Grid item xs={2} >

                                                                        <Conditional condition={props.assessment.participant_id!=props.user.emp_id}> 
                                                                            {unsur.staff_score}&nbsp;<CategoryLabel role="staff" unsur={unsur}/>
                                                                        </Conditional>
                                                                    
                                                                        <Conditional condition={props.assessment.participant_id==props.user.emp_id}>

                                                                            <Grid item container spacing={8} justify="flex-center" alignItems="center" className={classes.unsur_score} >
                                                                                <Grid item>
                                                                                    {unsur.is_optional===1 &&
                                                                                        <Tooltip title="optional">
                                                                                            <span className={classes.optional}>*</span>
                                                                                        </Tooltip>
                                                                                    }
                                                                                    {unsur.external_data &&
                                                                                        <Tooltip title="external data">
                                                                                         <span className={classes.optional}>*</span>
                                                                                        </Tooltip>
                                                                                    }
                                                                                    

                                                                                    
                                                                                {/* </Grid>

                                                                                <Grid item> */}
                                                                                <TextField
                                                                                type="number"
                                                                                margin="dense"
                                                                                InputLabelProps={{
                                                                                    shrink: true
                                                                                }}
                                                                                inputProps={{
                                                                                    min:
                                                                                        "0",
                                                                                    max:
                                                                                        "4",
                                                                                    step:
                                                                                        "0"
                                                                                }}
                                                                                onChange={(event)=>staffUnsurChange(unsur.id,event)}
                                                                                value={
                                                                                    unsur.staff_score
                                                                                }
                                                                                />
                                                                                <br /><br />
                                                                                <CategoryLabel role="staff" unsur={unsur}/>

                                                                                </Grid>

                                                                            </Grid>

                                                                        </Conditional>
                                                                        
       
                                                                    </Grid> 
                                                                </Grid>
                                                            </Grid>
                                                        ))}
                                                </Grid>
                                            ))}
                                    </Grid>
                                ))}
                        </Grid>

                        <Grid container justify="space-between" className={classes.grand_total}>
                            <Grid item xs={2}> Grand Total</Grid>
                            <Grid item xs={1} container justify="flex-end"> {grandTotal.toFixed(2)}</Grid>
                        </Grid>
                        <Grid container justify="space-between" className={classes.grand_total}>
                            <Grid item xs={2}> Kategori</Grid>
                            <Grid item xs={1} container justify="flex-end"> {category}</Grid>
                        </Grid>

                        { props.user.emp_id == props.assessment.atasan_id &&
                        <Grid container className={classes.note_container}>
                            <DebouncedTextField
                                id="note"
                                label="Note From Leader"
                                key_id_1 ="note"
                                value={noteAtasan}
                                margin="dense"
                                variant="outlined"
                                fullWidth
                                onChange={noteChange}
                            />
                        </Grid>
                        }
                        <Grid
                            spacing={8}
                            container
                            justify="flex-end"
                            className={classes.marginTops}
                        >
                            <Grid item>
                                <Button onClick={() => props.history.goBack()} size="small">
                                    Back
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    onClick={handleSubmit}
                                    variant="contained"
                                    size="small"
                                    color="primary"
                                    disabled={isSave===true ? true : false}
                                >
                                    Save 
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>


                <Modal
                    aria-labelledby="modal"
                    aria-describedby="modal"
                    open={isError}
                    onClose={()=>setIsError(false)}
                >
                    <div className={classes.paper}>
                    {
                        isError && <h2 id="modal-title">Incomplete form</h2>
                    }

                    <p id="modal-description">
                        Please fill all the non optional score
                    </p>
                    </div>
                </Modal>
            </React.Fragment>
        );
    }else{
        return null
    }

};

const styles = theme => ({
    container: {
        marginTop: -16,
        marginLeft: 5
    },
    marginTops: {
        marginTop: 10
    },
    sub_aspek: {
        paddingLeft: 10
    },
    unsur: {
        paddingLeft: 10
    },
    aspek_container:{
        border: "1px solid #c4c4c4",
        borderRadius:4,
        margin:"5px 0 5px 0"
    },
    aspek_row:{
        padding:5,
        backgroundColor:"#d2fce4",
        borderBottom: "1px solid #c4c4c4",
        color:"red",
        fontWeight: "bold",
    },
    aspek_score:{
        display:"flex",
        justifyContent:"flex-end",
        fontWeight: "bold",
        fontSize:17,
        color:"red"
    },
    sub_aspek_row:{
        padding:5,
        backgroundColor:"#7fcbfb",
        borderLeft: "1px solid #c4c4c4",
        borderBottom: "1px solid #c4c4c4",

    },
    sub_aspek_score:{
        display:"flex",
        justifyContent:"flex-end",
        fontWeight: "bold",
        fontSize:13,
        color:"#000000"
    },
    unsur_row:{
        padding:5,
        borderLeft: "1px solid #c4c4c4",
        borderBottom: "1px solid #c4c4c4",

    },


    labelScore:{
        fontSize:12
    },

    notFilled:{
        color:"#FF0000"
    },

    grand_total:{
        backgroundColor:"#fdfbbd",
        color:"#be0609",
        fontWeight: "bold",
        padding:"5px 10px 5px 10px",
        border: "1px solid #c4c4c4",
        borderRadius:4,
        margin:"5px 0 5px 0"
    },
    table_header:{
        backgroundColor:"#ffdb76",
        padding :5,

    },
    centeredCell:{
        display:"flex",
        alignContent:"center"
    },
    note_container:{
        marginTop:20
    }



});


const mapStateToProps = state => {
    return {
        user: state.user.user,
        assessment: state.assessment.data_assessment
    };
};

const PaDoAssessment = connect(mapStateToProps)(PaDoAssessmentComponent);

export default withRouter(withStyles(styles)(PaDoAssessment));
